<template>
    <div class="qksm qksm9">
        <h4>九、一般公共预算 “三公”经费、会议费、培训费支出情况说明</h4>
        <div class="nogap">
            <p><b>(一)一般公共预算 “三公”经费支出总体情况说明。</b></p>
            <p>
                2021年度一般公共预算 “三公”经费支出决算{{isMoney(T9.总计)}}万元。
                <span class="hide_pdf">
                    （去年决算数<reason type="money" classname="qksm money nullable" name="T9总计去年" v-model:value="T9.items_last.三公总计"></reason>万元）
                </span>
                <template v-if="num(T9.总计)==num(T9.items_last.三公总计)">
                    与上年决算数相同。
                </template>
                <template v-else>
                    与上年相比，{{growthValueText(num(T9.总计), num(T9.items_last.三公总计))}}万元，变动原因：
                    <reason type="textarea" classname="qksm widest" name="T9总计原因" v-model:value="qksm['T9总计原因']"></reason>
                </template>
                <template v-if="num(T9.总计)>0">
                    其中，
                    <span v-for="(item, idx) in T9.items[0].children" :key="idx">
                        {{item.name}}支出{{isMoney(item.决算)}}万元，占“三公”经费的{{getPercentValue(T9.items[0].children.map(e=>e.决算), idx, 2)}}{{idx==T9.items[0].children.length-1?'。':'；'}}
                    </span>
                </template>
            </p>
            <template v-for="(item,idx) in T9.items" :key='item.name'>
                <p><b>{{T9.items.length>1 ? "（"+intToChinese(idx+2)+"）" :""}}{{item.name == '三公经费' ? '一般公共预算 “三公”经费支出具体情况说明。' : `一般公共预算${item.name}支出决算情况说明。`}}</b></p>
                <template v-if="item.name == '三公经费'">
                    <p v-for="(a,aIdx) in item.children" :key="a.name">
                        {{aIdx+1}}.{{a.name}}支出预算{{isMoney(a.预算)}}万元，支出决算{{isMoney(a.决算)}}万元，
                        <template v-if="num(a.预算) == num(a.决算)">
                            完成年初预算的100%。决算数与年初预算数相同，
                        </template>
                        <template v-else>
                            <template v-if="num(a.预算)==0">
                                （预算数为0万元，无法计算完成比例）。
                            </template>
                            <template v-else>
                                完成预算的{{calcRatio(a.决算,a.预算)}}，
                            </template>
                            <template v-if="calcRatio(a.决算,a.预算).indexOf('四舍五入后为100%')>-1">
                                决算数与年初预算数基本持平。
                            </template>
                            <template v-else>
                                决算数与预算数的差异原因：
                                <reason type="textarea" classname="qksm widest" :name="'T9'+a.name+'原因'" v-model:value="qksm['T9'+a.name+'原因']"></reason>
                            </template>
                        </template>
                        <span v-if="a.name == '因公出国(境)费'">
                            全年使用一般公共预算财政拨款涉及的出国(境)团组{{a.more[0]}}个，累计{{a.more[1]}}人次。
                            <template v-if="num(a.决算)!=0">
                                。开支内容：
                                <reason type="textarea" classname="qksm widest" name="因公出国为" v-model:value="qksm['因公出国为']"></reason>
                            </template>
                        </span>
                        <span v-else>
                            其中:
                            <template v-for='(b,bidx) in a.children' :key='b.name'>
                                <p v-if="a.name == '公务用车购置及运行维护费'">
                                    ({{bidx+1}})公务用车{{b.name}}支出决算{{isMoney(b.决算)}}万元。
                                    <span v-if="b.name == '购置'">
                                        本年度使用一般公共预算财政拨款购置公务用车{{b.more[0]}}辆
                                        <template v-if="num(b.决算)!=0">
                                            ，开支内容：
                                            <reason type="textarea" classname="qksm widest" :name="b.name + '为'" v-model:value="qksm[b.name + '为']"></reason>
                                        </template>
                                        <template v-else>
                                            。
                                        </template>
                                    </span>
                                    <span v-if="b.name == '运行维护费'">
                                        公务用车运行维护费主要用于按规定保留的公务用车的燃料费、维修费、过桥过路费、保险费、安全奖励费用等支出。截至2021年12月31日，使用一般公共预算财政拨款开支的公务用车保有量为{{b.more[0]}}辆。
                                    </span>
                                </p>
                                <span v-if="a.name == '公务接待费'">
                                    {{b.name}}公务接待支出{{isMoney(b.决算)}}万元，接待{{b.more[0]}}批次,{{b.more[1]}}人次
                                    <template v-if="num(b.决算)!=0">
                                        ， 开支内容：
                                        <reason type="textarea" classname="qksm widest semicolon" :name="'T9'+b.name+'为'" v-model:value="qksm['T9'+b.name+'为']"></reason>
                                    </template>
                                    <template v-else>
                                        {{bidx+1 == a.children.length ? '。' : '；'}}
                                    </template>
                                </span>
                            </template>
                        </span>
                    </p>
                </template>
                <template v-else>
                    <p>
                        2021年度一般公共预算财政拨款{{item.name}}支出预算{{isMoney(item.预算)}}万元 ，支出决算{{isMoney(item.决算)}}万元，
                        <template v-if="num(item.预算) == num(item.决算)">
                            完成年初预算的100%，决算数与年初预算数相同，
                        </template>
                        <template v-else>
                            <template v-if="num(item.预算)==0">
                                （预算数为0万元，无法计算完成比例）。
                            </template>
                            <template v-else>
                                完成预算的{{calcRatio(item.决算,item.预算)}}，
                            </template>
                            <template v-if="calcRatio(item.决算,item.预算).indexOf('四舍五入后为100%')>-1">
                                决算数与年初预算数基本持平。
                            </template>
                            <template v-else>
                                决算数与预算数的差异原因：
                                <reason type="textarea" classname="qksm widest" :name="'T9'+item.name+'原因'" v-model:value="qksm['T9'+item.name+'原因']"></reason>
                            </template>
                        </template>
                        2021年度全年{{item.name == '会议费' ? `召开会议${item.more[0]}个，参加会议${item.more[1]}人次 ` : `组织培训${item.more[0]}个，组织培训${item.more[1]}人次`}}
                        <template v-if="num(item.决算)!=0">
                            ，开支内容：
                            <reason type="textarea" classname="qksm widest" :name="'T9'+item.name+'为'" v-model:value="qksm['T9'+item.name+'为']"></reason>
                        </template>
                        <template v-else>
                            。
                        </template>
                    </p>
                </template>
            </template>
        </div>
    </div>
</template>
<script>
    import reason from "@/components/reason.vue";
    export default {
        name: "qksm9",
        data() {
            var qksm = this.$store.state.divData.qksm;
            if (qksm['T9总计去年']){
                this.T9.items_last['三公总计'] = qksm['T9总计去年'];
            }
            this.T9.items.find(el=>el.name == '三公经费').children.forEach(e=>{
                if(e.name == '公务接待费'){
                    e.children.forEach(ele=>{
                        if(ele.name == '国内'){
                            ele.决算 = this.num(this.T14.国内公务接待支出)
                        }
                        if(ele.name == '国(境)外'){
                            ele.决算 = this.num(this.T14.国外公务接待支出)
                        }
                    })
                }
            })
            return {
                isPdf: this.$parent.isPdf,
                qksm: qksm
            }
        },
        props: {
            T9: {
                type: Object,
                default: "",
            },
            T14: {
                type: Object,
                default: "",
            },
        },
        components: {
            reason,
        },
        created() {
            this.inspect()
        },
        methods: {
            inspect() {
                this.T9.items.forEach((a,aInx)=>{
                    if(a.children){ //三公经费
                        a.children.forEach((el,idx)=>{
                            if(!el.children){ //因公出国(境)费
                                if(el.more){
                                    let flag = false
                                    if(el.决算 == 0){el.more.forEach(e=>{e == 0 ? '' : flag = 1})}
                                    if(el.决算 > 0){el.more.forEach(e=>{e > 0 ? '' : flag = 2})}
                                    flag ? this.addOrSet(`qksm9${aInx}${idx}`, `请检查本页《九、一般公共预算“三公”经费、会议费、培训费支出情况说明》（二）一般公共预算“三公”经费支出具体情况说明，${el.name}支出决算${flag == 1 ? '为' : '大于'}0全年使用一般公共预算财政拨款涉及的出国（境）团组或累计人次应${flag == 1 ? '为' : '大于'}0。`) : this.remove(`qksm9${aInx}${idx}`)
                                }
                            }else{
                                el.children.forEach((ele,index)=>{
                                    if(ele.name != '运行维护费'){
                                        if(ele.more){
                                            let flag = false
                                            if(ele.决算 == 0){ele.more.forEach(e=>{e == 0 ? '' : flag = 1})}
                                            if(ele.决算 > 0){ele.more.forEach(e=>{e > 0 ? '' : flag = 2})}
                                            flag ? this.addOrSet(`qksm9${aInx}${idx}${index}`, `请检查本页《九、一般公共预算“三公”经费、会议费、培训费支出情况说明》（二）一般公共预算“三公”经费支出具体情况说明，${el.name == '公务用车购置及运行维护费' ? `公务用车${ele.name}` : `${ele.name}公务接待`}支出决算${flag == 1 ? '为' : '大于'}0全年使用一般公共预算财政拨款涉及的出国（境）团组或累计人次应${flag == 1 ? '为' : '大于'}0。`) : this.remove(`qksm9${aInx}${idx}${index}`)
                                        }
                                    }
                                })
                            }
                        })
                    }else{
                        if(a.more){
                            let flag = false
                            if(a.决算 == 0) {a.more.forEach(e=>{e == 0 ? '' : flag = 1})}
                            if(a.决算 > 0){a.more.forEach(e=>{e > 0 ? '' : flag = 2})}
                            flag ? this.addOrSet(`qksm9${aInx}`, `请检查本页《九、一般公共预算“三公”经费、会议费、培训费支出情况说明》${a.name == '会议费' ? `（三）一般公共预算会议费支出决算情况说明，2021年度一般公共预算财政拨款会议费支出决算${flag == 1 ? '为' : '大于'}0,2021年度全年召开会议个数或参加会议人次应${flag == 1 ? '为' : '大于'}0。` : `（二）一般公共预算“三公”经费支出具体情况说明，2021年度一般公共预算财政拨款培训费支出决算${flag == 1 ? '为' : '大于'}0，2021年度全年组织培训个数或组织培训人次应${flag == 1 ? '为' : '大于'}0。`}`) : this.remove(`qksm9${aInx}`)
                        }
                    }
                })
                if (this.num(this.T9.items[0].children[2].决算).toFixed(2) != this.num(this.num(this.T14.国内公务接待支出) + this.num(this.T14.国外公务接待支出)).toFixed(2)) {
                    this.addOrSet("qksm9", "请检查本页《九、一般公共预算 “三公”经费、会议费、培训费支出情况说明》，国内公务接待支出金额+国（境）外公务接待支出金额与公务接待费支出决算总额不相等。");
                } else {
                    this.remove("qksm9")
                }
            }
        }
    };
</script>